import ChatWindow from './ChatWindow.jsx';

export default function ChatDock({
  conversations, selfId, onlineActorIds, onSend, onTyping, onClose, onToggleMin,
  onAddFriend, isFriend,
}) {
  if (conversations.length === 0) return null;
  return (
    <div className="chat-dock">
      {conversations.map((conv) => (
        <ChatWindow
          key={conv.key}
          conv={conv}
          selfId={selfId}
          online={onlineActorIds.has(conv.peer.id)}
          onSend={onSend}
          onTyping={onTyping}
          onClose={onClose}
          onToggleMin={onToggleMin}
          onAddFriend={onAddFriend}
          isFriend={isFriend?.(conv.peer.id)}
        />
      ))}
    </div>
  );
}
